/* eslint-disable linebreak-style */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import styles from '../../../SignIn/style';
import { LockOpenOutlined, Visibility, VisibilityOff } from '@material-ui/icons';
import validate from 'validate.js';
import schema from './schemaActivateAccount';
import {
  TextField,
  Button,
  Typography,
  withStyles,
  CircularProgress,
  Box,
  InputAdornment,
  IconButton,
  Grid
} from '@material-ui/core';
import {
  EHRresetpassword,
  getUserByUsername
} from 'services/user/action';

import { login } from 'services/profile/action';

import { connect } from 'react-redux';
import MessageBox from 'util/messageBox';

const Passwordreset = props => {
  const { classes } = props;
  const [tokenInvalid, setTokenInvalid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [values, setValues] = useState({
    token: '',
    username: '',
    password: '',
    confirmpassword: '',
    succMsg: false,
    touched: {},
    errors: {},
    isValid: false,
  });

  useEffect(() => {
    // let ntoken =
    //   props.history && props.history.location && props.history.location.search ;
    // ntoken = ntoken.slice(7);
    // setValues({...values,token:ntoken});
    fetchUser();
  }, []);

  const parseQueryString = url => {
    var objURL = {};
    url.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), function (
      _$0,
      $1,
      _$2,
      $3
    ) {
      objURL[$1] = $3;
    });
    return objURL;
  };

  const hasError = field =>
    values &&
      values.touched &&
      values.errors &&
      values.touched[field] &&
      values.errors[field]
      ? true
      : false;

  const fetchUser = async () => {
    let url = window.location.href;
    var params = parseQueryString(url);
    const res = await props.EHRresetpassword(params['token']);
    if (res.status === 200) {
      let newurl = res.data;
      var loginparams = parseQueryString(newurl);
      if (loginparams['username']) {
        // const userRes = await props.getUserByUsername(
        //   loginparams['ehrid'],
        //   loginparams['username']
        // );
        // if(userRes.status){
        // const loginStatus = await props.login(
        //   userRes.data.username,
        //   userRes.data.password,
        //   false,
        //   true
        // );
        // if (userRes.status) {
        setValues({
          ...values,
          ehrid: loginparams['ehrid'],
          token: params['token']
        });
        //   }
        // }
      }
    } else {
      setTokenInvalid(true);
    }
  };

  const handleFieldChange = (field, value) => {
    const newState = { ...values };
    newState[field] = value;
    newState.touched[field] = true;
    let errors = validate(newState, schema);
    if (field === 'username') {
      const username = value || '';
      // allow empty / null, otherwise enforce letters+numbers only
      const re = /^[A-Za-z0-9]+$/;
      if (username !== '' && !re.test(username)) {
        if (!errors) {
          errors = {};
        }
        errors.username = ['Username can contain only letters and numbers.'];
      }
    }
    newState.errors = errors || {};
    newState.isValid = errors ? false : true;
    setValues(newState);
    if (values) {
      // setIsBlocking(true);
    }
  };
  const validateForm = () => {
    const newState = { ...values };
    const errors = validate(newState, schema);
    if (newState.username && newState.username !== '') {
      const username = newState.username || '';
      // allow empty / null, otherwise enforce letters+numbers only
      const re = /^[A-Za-z0-9]+$/;
      if (username !== '' && !re.test(username)) {
        errors.username = ['Username can contain only letters and numbers.'];
      }
    }
    newState.errors = errors || {};
    newState.isValid = errors ? false : true;
    setValues(newState);

    return newState.isValid;
  };
  const handleSubmit = async () => {
    if (validateForm()) {
      setIsLoading(true);
      let newState = {
        username: values.username,
        password: btoa(values.password),
        confirmpassword: values.password,
        ehrid: values.ehrid,
        token: values.token
      };
      props.getUserByUsername(values.ehrid, values.username).then(res => {
        if (res && res.data && res.data.username === values.username) {
          setIsLoading(false);
          setError('Username already exists. Please choose a different username.');
        } else {
          setError(null);
          props.history.push({
            pathname: '/terms',
            state: { data: newState }
          });
        }
      })

    }

    // setIsBlocking(false);
    // props.onCancel();
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  const handleClickShowConfirmPassword = () => {
    setValues({ ...values, showConfirmPassword: !values.showConfirmPassword });
  };

  const handleClose = () => {
    setError(null);
  };

  return (
    <span>
      <div
        className={classes.contentBodyMsg}
        style={{ position: 'relative' }}
      >
        <div className={classes.contentHeader}>
          <LockOpenOutlined />
          <Typography variant="h1">Activate Your Account</Typography>
        </div>

        <MessageBox
          message={error}
          onClose={handleClose}
          open={error ? true : false}
          variant="error"
        />
        <div className={classes.contentInner}>
          {tokenInvalid ? (
            <Box
              sx={{
                mb: 2,
                p: 2,
                borderRadius: 2,
                bgcolor: '#F3F4F6',
                border: '1px solid #E5E7EB'
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center'
                }}
              >
                <Typography variant="h5" color="error" gutterBottom>
                  This activation link is invalid or has expired. Please contact
                  support <a href="mailto:admin@ehrzip.com">admin@ehrzip.com</a>.
                </Typography>
              </Box>
            </Box>
          ) : values?.token ? (
            <Box
              sx={{
                width: '100%',
                maxWidth: 550,
                mx: 'auto',
                mb: 2,
                px: { xs: 2, sm: 0 }
              }}
            >
              <Grid container spacing={2} direction="column">
                {/* Username */}
                <Grid item>
                  <TextField
                    color="primary"
                    fullWidth
                    InputLabelProps={{
                      classes: {
                        focused: classes.labelFocused
                      }
                    }}
                    error={Boolean(values.errors && values.errors.username)}
                    label="Username"
                    name="username"
                    required
                    value={values.username}
                    onChange={event =>
                      handleFieldChange('username', event.target.value)
                    }
                    helperText={
                      hasError('username') ? values.errors.username[0] : ''
                    }
                    variant="outlined"
                  />
                </Grid>

                {/* New Password */}
                <Grid item>
                  <TextField
                    color="primary"
                    fullWidth
                    type={values.showPassword ? 'text' : 'password'}
                    label="New Password"
                    name="npw"
                    variant="outlined"
                    InputLabelProps={{
                      classes: {
                        focused: classes.labelFocused
                      }
                    }}
                    error={Boolean(values.errors && values.errors.password)}
                    helperText={
                      hasError('password') ? values.errors.password[0] : ''
                    }
                    value={values.password}
                    onChange={event =>
                      handleFieldChange('password', event.target.value)
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            size="small"
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                          >
                            {values.showPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                    sx={{
                      '& .MuiInputBase-input::placeholder': {
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                      }
                    }}
                  />
                </Grid>

                {/* Confirm New Password */}
                <Grid item>
                  <TextField
                    color="primary"
                    fullWidth
                    type={values.showConfirmPassword ? 'text' : 'password'}
                    label="Confirm Password"
                    name="cnpw"
                    variant="outlined"
                    InputLabelProps={{
                      classes: {
                        focused: classes.labelFocused
                      }
                    }}
                    error={Boolean(
                      values.errors && values.errors.confirmpassword
                    )}
                    helperText={
                      hasError('confirmpassword')
                        ? values.errors.confirmpassword[0]
                        : ''
                    }
                    value={values.confirmpassword}
                    onChange={event =>
                      handleFieldChange('confirmpassword', event.target.value)
                    }
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            edge="end"
                            size="small"
                            aria-label="toggle confirm password visibility"
                            onClick={handleClickShowConfirmPassword}
                          >
                            {values.showConfirmPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      '& .MuiInputBase-input::placeholder': {
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden'
                      }
                    }}
                  />
                </Grid>

                {/* Submit button */}
                <Grid item>
                  <Button
                    color="primary"
                    onClick={handleSubmit}
                    variant="contained"
                    disabled={isLoading}
                    fullWidth
                  >
                    {isLoading && (
                      <CircularProgress
                        size={20}
                        style={{ marginRight: 5 }}
                        color="inherit"
                      />
                    )}
                    Activate account
                  </Button>
                </Grid>
              </Grid>
            </Box>
          ) : (
            <CircularProgress size={30} color="primary" />
          )}
        </div>
      </div>
    </span>
  );
};

Passwordreset.propTypes = {
  history: PropTypes.object
};

const mapDispatchToProps = {
  EHRresetpassword,
  login,
  getUserByUsername
};

const mapStateToProps = _state => ({
  //user:state.user
  // titles: state.util.titles,
  //ehrID: state.profile && state.profile.ehrID,
  // // userID: state.profile && state.profile.userID,
  //username: state.profile && state.profile.name
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withStyles(styles)(Passwordreset))
);
